import React, { useState } from 'react';
import axios from 'axios';
import { useToast } from '../Admissionform/ToastManager'; // Update the path accordingly


// Hardcoded departments

const departments = ["CADD", "Pumo Tech IT","Pumo Tech Automation", "Monz Creative School"];


const CourseCreationForm = ({ onClose }) => {
  const [courseData, setCourseData] = useState({
    courseType: '',
    courseName: '',
    courseFees: '',
    courseDuration: ''
  });
    const { showSuccess, showError } = useToast();


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCourseData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleCreateCourse = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/create-course`,
        courseData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("Course created:", response.data);
      showSuccess("Course created successfully!");
      onClose();
      setCourseData({
        courseType: '',
        courseName: '',
        courseFees: '',
        courseDuration: ''
      });
    } catch (error) {
      console.error("Error creating course:", error);
      showError("Failed to create course: " + (error.response?.data?.message || error.message));
    }
  };

  return (
    <div className="employee-form-modal">
      <div className="employee-form-container">
        <div className="form-header">
          <h2>Create New Course</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleCreateCourse}>
          <div className="form-group">
            <label>Course Type:</label>
            <select
              name="courseType"
              value={courseData.courseType}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Course Type</option>
              {departments.map((dept) => (
                <option key={dept} value={dept}>
                  {dept}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Course Name:</label>
            <input
              type="text"
              name="courseName"
              value={courseData.courseName}
              onChange={handleInputChange}
              required
              placeholder="Enter course name"
            />
          </div>

          <div className="form-group">
            <label>Course Fees:</label>
            <input
              type="number"
              name="courseFees"
              value={courseData.courseFees}
              onChange={handleInputChange}
              required
              placeholder="Enter course fees"
              step="0.01"
            />
          </div>

          <div className="form-group">
            <label>Course Duration (Hours):</label>
            <input
              type="number"
              name="courseDuration"
              value={courseData.courseDuration}
              onChange={handleInputChange}
              required
              placeholder="Enter course duration in Hours"
              min="1"
            />
          </div>

          <div className="form-buttons">
            <button type="submit" className="submit-button">Create Course</button>
            <button type="button" className="cancel-button" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CourseCreationForm;
